import { render, staticRenderFns } from "./EditSCPage.vue?vue&type=template&id=ce5023bc&"
import script from "./EditSCPage.vue?vue&type=script&lang=js&"
export * from "./EditSCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports